module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("The Lightning climbed vertically in reheat into the darkening sky, and the reheat extinguished at exactly the same time that the music stopped. It was a very poignant moment, and a few tears were shed…")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("…But before then a few things would have to happen, if I was to fly a "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Glossary#g100",
      "id": "g_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lightning")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61fc6bc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Frontmatter.vue
// module id = 72
// module chunks = 0